// src/components/StampResultModal.js
import { useTranslation } from 'react-i18next';
import '../styles/QuizResultModal.css';

export default function StampResultModal({ isOpen, onClose, onReturnToMap }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleOverlayClick = (e) => { if (e.target === e.currentTarget) onClose(); };
  const handleButtonClick = () => { onReturnToMap(); };

  // 中央アイコン画像（固定でスタンプ）
  const ICON_SRC = '/images/stamp/stamp.svg';

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="quiz-result-modal correct">
        <div className="confetti-background">{/* 紙吹雪 */}</div>
        <div className="result-content">
          <h2 className="result-title">{t('stamp.getStamp')}</h2>
          <div className="result-icon">
            <img
              src={ICON_SRC}
              alt="スタンプ獲得"
              className="result-img"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          </div>
          <button className="result-button" onClick={handleButtonClick}>
            {t('quiz.backToMap')}
          </button>
        </div>
      </div>
    </div>
  );
}
